import './main.css';
import { useEffect } from 'react';

export function Main() {
  const achievements = [
    '日本情報オリンピック本選 14人（春合宿 1人）',
    '日本人工知能オリンピック 金賞 1人・銅賞 2人',
    '日本数学オリンピック 本選 1人',
    '国際原子力オリンピック 金メダル 1人'
  ];

  const studentVoices = [
    {
      name: 'Rkさん(情報オリンピック本選)',
      voice: 'この塾に入ったら、スポーツも勉強も全てがうまくいくようになりました！！この塾の全てに感謝しています！！！！',
    },
    {
      name: 'chocolate rabbitさん(日本人工知能オリンピック金賞, 数理最適化コンテスト中学部門1位)',
      voice: '入ってから180度世界の見え方が変わりました！そして、ともに高めあう仲間を見つけました！',
      audio: 'voice.mp3',
    },
    {
      name: '名無しさん(ゼロワングランドスラム2024年優勝)',
      voice: '気持ちの拠り所ができました！また、落合がたまに暴走します！',
    },
    {
      name: '富山さん(情報オリンピック本選)',
      voice: '半年でAtCoderのレートが600あがりました！ (事実)',
    },
    {
      name: 'S/7さん(小学4年生で数検1級合格+英検1級合格)',
      voice: 'AtCoderで順位表1ページ目に載れるようになりました'
    },
    {
      name: '256さん(kaggle Expert)',
      voice: 'ぶいすぽのキャラの名前を覚えられました！',
    },
    {
      name: 'いさん(情報オリンピック本選, 数学オリンピック本選)',
      voice: '胃内壁の中で形成される消化液である。塩酸、塩化カリウム、塩化ナトリウムで構成される。タンパク質のアミノ酸の長い鎖を分解する消化酵素を活性化するという重要な役割を果たしている。食後など、必要なときに胃酸の生産を増やすフィードバック機構がある。'
    },
    {
      name: '野菜さん(国際原子力オリンピック金メダル)',
      voice: 'うに'
    }
  ];

  const activities = [
    {
      label: 'ゲーム制作（Unity）',
      image: 'unity.png',
      alt: 'Unityの活動イメージ',
    },
    {
      label: 'Web開発',
      image: 'web.png',
      alt: 'Web開発の活動イメージ',
    },
    {
      label: '競技プログラミング',
      image: 'atcoder.png',
      alt: '競技プログラミングの活動イメージ',
    },
    {
      label: 'データサイエンス（Kaggle / SIGNATE）',
      image: 'kaggle.png',
      alt: 'データサイエンスの活動イメージ',
    },
    {
      label: 'IT系就活対策（ES添削など）',
      image: 'work.png',
      alt: '就活対策の活動イメージ',
    },
  ];

  const favoriteGames = ['Putt Party', '麻雀', 'マイクラ', 'コードネーム', '将棋', 'ジオゲッサー', '囲碁', 'クイズ', 'たほいや', 'ito'];

  const admissionMethods = [
    <>
      <a href="https://giftech.co.jp/service/zinmu/" target="_blank" rel="noreferrer" className="text-link">ZINMU</a>や
      <a href="https://shiki-sci.jp/" target="_blank" rel="noreferrer" className="text-link">シキサイ</a>
      に入会すると、本人が拒否しない限り自動所属。
    </>,
    'Xアカウントをフォロー。総合判断で勧誘DMが届くことがあります。',
    '既存メンバー経由で希望を伝えると、招待コードが送られます。',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            if (target.style.animationDelay) {
              target.style.transitionDelay = target.style.animationDelay;
            }
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-up').forEach((el) => observer.observe(el));

    const clickRipple = (event: MouseEvent) => {
      const ripple = document.createElement('span');
      ripple.className = 'global-ripple';
      ripple.style.left = `${event.clientX}px`;
      ripple.style.top = `${event.clientY}px`;
      document.body.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    };

    window.addEventListener('click', clickRipple);

    return () => {
      observer.disconnect();
      window.removeEventListener('click', clickRipple);
    };
  }, []);

  return (
    <main className="page">
      <header className="header">
        <div className="logo-area fade-up from-left">
          <img src="icon.jpg" alt="塾ロゴ" className="logo-icon-img" />
          <span className="logo-text">落合式プログラミング塾</span>
        </div>
      </header>

      <section className="hero">
        <div className="hero-content">
          <p className="eyebrow fade-up from-left" style={{ animationDelay: '0.1s' }}>無料オンラインコミュニティ</p>
          <h1 className="fade-up from-left" style={{ animationDelay: '0.2s' }}>
            <span className="block">プログラミングが</span>
            <span className="block highlight">好きな学生</span>
            <span className="block">集まれ。</span>
          </h1>
          <p className="hero-copy fade-up from-left" style={{ animationDelay: '0.3s' }}>
            Discord中心の学習コミュニティ。<br />
            原則毎週土日14:00から、作って学ぶ勉強会を開催中。
          </p>
          <div className="hero-actions fade-up from-left" style={{ animationDelay: '0.4s' }}>
            <a className="cta ghost" href="#admission">
              入塾方法を見る
            </a>
            <a
              href="https://x.com/ochiaishiki"
              target="_blank"
              rel="noreferrer"
              className="x-link-inline"
            >
              <img src="X.png" width={50} />
            </a>
          </div>
        </div>
      </section>

      <section className="section section-activities">
        <div className="section-inner layout-split">
          <div className="section-header fade-up from-left">
            <h2>活動内容</h2>
            <p className="subtitle">Activities</p>
          </div>
          <div className="content-text fade-up from-right">
            <p>皆で楽しくプログラミングを学び、時にはゲームで交流しながら、技術力と実践力を伸ばします。</p>
            <ul className="modern-list">
              {activities.map((item, i) => (
                <li
                  key={item.label}
                  className={`fade-up ${i % 2 === 0 ? 'from-left' : 'from-right'}`}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <img src={item.image} alt={item.alt} className="activity-thumb" />
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
            <p className="note fade-up from-left">
              能力が高い学生には、時給換算で2000円〜5000円程度になる開発案件やプログラミング指導を任せる場合があります。
            </p>
          </div>
        </div>
      </section>

      <section className="section section-achievements achievements fade-up from-right">
        <div className="section-inner layout-split">
          <div className="section-header">
            <h2>2025年度<br />塾生実績</h2>
            <p className="subtitle">Achievements</p>
          </div>
          <div className="content-text">
            <ul className="modern-list">
              {achievements.map((item, i) => (
                <li
                  key={item}
                  className={`fade-up ${i % 2 === 0 ? 'from-right' : 'from-left'}`}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <span className="icon">🏆</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section section-voices">
        <div className="section-inner layout-split">
          <div className="section-header fade-up from-left">
            <h2>生徒の声</h2>
            <p className="subtitle">Voices</p>
          </div>
          <div className="content-text">
            <div className="voice-grid">
              {studentVoices.map((item, i) => (
                <blockquote
                  key={`${item.name}-${i}`}
                  className={`voice-card fade-up ${i % 2 === 0 ? 'from-right' : 'from-left'}`}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <span className="voice-mark">“</span>
                  <p>{item.voice}</p>
                  {item.audio ? (
                    <p className="voice-audio-row">
                      <span>生徒の”声”:</span>
                      <audio className="voice-audio" controls preload="none">
                        <source src={item.audio} type="audio/mpeg" />
                        お使いのブラウザは音声再生に対応していません。
                      </audio>
                    </p>
                  ) : null}
                  <span className="voice-name">{item.name}</span>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section section-games">
        <div className="section-inner layout-split">
          <div className="section-header fade-up from-left">
            <h2>よくやるゲーム</h2>
            <p className="subtitle">Games</p>
          </div>
          <div className="content-text fade-up from-right">
            <ul className="modern-list">
              {favoriteGames.map((game, i) => (
                <li
                  key={game}
                  className={`fade-up ${i % 2 === 0 ? 'from-left' : 'from-right'}`}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <span>{game}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section section-admission" id="admission">
        <div className="section-inner layout-split">
          <div className="section-header fade-up from-left">
            <div className="section-heading-row">
              <h2>入塾方法</h2>
            </div>
            <p className="subtitle">Admission</p>
          </div>
          <div className="content-text">
            <div className="steps">
              {admissionMethods.map((item, i) => (
                <div
                  className={`step-card fade-up ${i % 2 === 0 ? 'from-left' : 'from-right'}`}
                  key={i}
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <div className="step-number">0{i + 1}</div>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section section-scholar scholar fade-up from-left">
        <div className="section-inner layout-split">
          <div className="section-header">
            <h2>特待生制度</h2>
            <p className="subtitle">Scholarship</p>
          </div>
          <div className="content-text border-box fade-up from-right" style={{ animationDelay: '0.1s' }}>
            <p>
              優秀な学生には特待生ロールを付与。<br />
              歓迎会の開催、閲覧可能チャンネルの拡張、各種優先権など、学習に集中しやすい特典があります。<br />
              例: オフ会での焼肉で1品追加
              <img src="sushi.png" width={500} />
            </p>
          </div>
        </div>
      </section>

      <footer className="footer fade-up from-left">
        <p>&copy; {new Date().getFullYear()} 落合抜プログラミング塾</p>
      </footer>
    </main>
  );
}
